/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

/**
 * Client-generated idempotency key for `bookAppointment` (03 §5). Uses
 * `crypto.randomUUID` where available (browsers in a secure context) and falls
 * back to a random string elsewhere (e.g. jsdom) — uniqueness is all the server
 * needs to dedupe a double-submit.
 */
// Fallback counter for environments without Web Crypto (e.g. jsdom): a timestamp +
// in-process counter is unique per call, so the server can still dedupe a double-
// submit — no PRNG (and thus no weak-randomness concern) needed.
let fallbackCounter = 0

const generateRequestId = (): string => {
  const cryptoRef = (globalThis as unknown as { crypto?: { randomUUID?: () => string } }).crypto
  if (cryptoRef && typeof cryptoRef.randomUUID === "function") {
    return cryptoRef.randomUUID()
  }
  fallbackCounter += 1
  return `req-${Date.now().toString(36)}-${fallbackCounter.toString(36)}`
}

export default generateRequestId
